"use strict";

const getAllProductGroups = products => products.map(product => product.productListGroup ?? null);
const groupProducts = products => {
  const result = [];
  let current = {
    productListGroup: null,
    span: 0
  };
  for (const productListGroup of getAllProductGroups(products)) {
    const productListGroupId = productListGroup?.id ?? null;
    if (productListGroupId === (current.productListGroup?.id ?? null)) {
      current.span++;
      continue;
    }
    result.push(current);
    current = {
      productListGroup,
      span: 1
    };
  }
  if (current.span) {
    result.push(current);
  }
  return result.filter(x => !!x.span);
};
export { groupProducts };
//# sourceMappingURL=groupProducts.mjs.map
